/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Partner_Referral_Delete_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "The code {code} has never attributed a customer, so nothing is lost. Any link already shared will stop working." |
*
* @param {Partner_Referral_Delete_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_delete_confirm_body = /** @type {((inputs: Partner_Referral_Delete_Confirm_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Delete_Confirm_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Code ${i?.code} hat noch keinen Kunden zugeordnet, es geht also nichts verloren. Bereits geteilte Links funktionieren danach nicht mehr.`)
	return /** @type {LocalizedString} */ (`The code ${i?.code} has never attributed a customer, so nothing is lost. Any link already shared will stop working.`)
});